<template>
	<div>
		<div class="checkbox-wrapper">
			<input
				:id="id"
				:name="id"
				class="screen-reader"
				:aria-label="`${label} ${price ? showPrice(price.trim()) : ''}`"
				type="checkbox"
				@click="$emit('input', { optionId: id, optionName: label, price: price })"
				@keyup.enter="$emit('input', { optionId: id, optionName: label, price: price })"
			/>
			<label :class="['checkbox-label', { isSelected: value }]" :for="id">
				<div v-show="value" class="checkbox-checked-icon"></div>
				<img
					v-if="isAlcohol"
					:src="$CDN + '/images/alcohol.svg'"
					loading="lazy"
					title="Alcohol"
					alt="Alcohol icon"
					class="icon"
					style="height: auto; width: 15px; margin-right: 5px"
				/>
				<div class="label-wrapper">
					<span>{{ label }}</span>
					<i
						v-if="hasNestedOptions && !Object.keys(getNestedOptionsSelected).length"
						class="fas fa-chevron-right has-nested-indicator"
					></i>
				</div>
				<span v-if="price"> {{ showPrice(price.trim()) }}</span>
				<span v-else>&nbsp;</span>
			</label>
		</div>
		<nested-selections
			v-if="Object.keys(getNestedOptionsSelected).length"
			:nestedSelections="getNestedOptionsSelected"
			:parentLabel="label"
			@editNestedSelections="$emit('editNestedSelections', id)"
		/>
	</div>
</template>

<script>
import NestedSelections from "./NestedSelections.vue";

export default {
	name: "AddItemInputCheckbox",
	components: {
		NestedSelections,
	},
	props: {
		id: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		value: {
			type: Boolean,
			default: false,
		},
		price: {
			type: String,
		},
		isAlcohol: {
			type: Boolean,
			default: false,
		},
		parentID: {
			type: Number,
			default: null,
		},
		hasNestedOptions: {
			type: Boolean,
			default: false,
		},
		allNestedOptionsSelected: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		getNestedOptionsSelected: function () {
			var nestedOptionsSelected = {};
			this.allNestedOptionsSelected.forEach((option) => {
				if (option.parentID == this.id) {
					if (!nestedOptionsSelected[option.optionGroupName]) {
						nestedOptionsSelected[option.optionGroupName] = {};
						nestedOptionsSelected[option.optionGroupName].selections = [];
					}
					nestedOptionsSelected[option.optionGroupName].selections.push(option);
				}
			});
			return nestedOptionsSelected;
		},
	},
	methods: {
		showPrice(price) {
			if (price < 0) {
				price = price.replace("-", "");
				return `-$${price}`;
			} else {
				return `+$${price}`;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
$checkbox-size: 20px;

.screen-reader {
	@include screen-reader-text;
}

.checkbox-wrapper {
	margin-bottom: 10px;
	width: 100%;

	:not(:last-of-type) {
		margin-right: 5px;
		width: 100%;
	}
}

.checkbox {
	display: none;
}

.checkbox-label {
	position: relative;
	font-weight: 700;
	font-size: 1.4rem;
	line-height: 1;
	display: flex;
	align-items: center;
	cursor: pointer;
	width: 100%;
	transition: color 0.1s ease;

	&:hover,
	&:focus {
		.has-nested-indicator {
			color: $tomato;
		}
		color: $tomato;
	}

	&::before {
		content: "";
		display: block;
		height: $checkbox-size;
		width: $checkbox-size;
		background-color: $gray_3;
		margin-right: 10px;
		padding-right: 20px;
	}
}

.label-wrapper {
	width: 100%;
	align-items: center;
	display: flex;
}

.checkbox-checked-icon {
	position: absolute;
	height: 18px;
	width: 18px !important;

	&::before,
	&::after {
		content: "";
		display: block;
		background-color: $tomato;
		width: 2px;
		height: 20px;
		position: absolute;
		top: 10%;
		left: 58%;
	}

	&::before {
		transform: translate(-50%, -2px) rotate(45deg);
	}

	&::after {
		transform: translate(-50%, -2px) rotate(-45deg);
	}
}

.checkbox:checked + .checkbox-label {
	.checkbox-checked-icon {
		display: block;
	}
}

.isSelected {
	color: $tomato;
}

.has-nested-indicator {
	margin-left: 10px;
	color: $gray_10;
	font-size: 20px;
	transition: color 0.1s ease;
}
</style>
